<template>
  <div class="spo-card pa-2 rounded my-2" :style="{ 'background-color': get_background(course) }">
    <v-row>
      <v-col>
        <div class="text-h5 font-weight-bold">{{ course.nom }}</div>
        <div v-if="display_depart">
          Départ : {{ date_depart }} {{ heure_depart }}
        </div>
        <CourseProperties :course="course"></CourseProperties>

        <!-- Indications supplémentaires -->
        <CourseInformationsTruncated :text="course.metadatas.indications" :maxLines="3" class="mt-2" />
        <!-- Propriété de la course en liste d'icones -->
      </v-col>

      <v-col cols="12" lg="3" xl="2">
        <!-- Bouton _s'inscrire_ de préselection -->

        <div v-if="show_inscription_button">
          <SportipsButton @onClick="addToPreselection(course)" icon="mdi-pencil-plus-outline" chevron action-button
            full-width>
            {{ has_preinscriptions ? 'Se préinscrire' : 'S\'inscrire' }}
          </SportipsButton>
          <!-- Section tarif de la course -->
          <TarifsCourse :tarifs="course.tarifs" :course="course"></TarifsCourse>
        </div>

        <!-- Bouton disabled si les inscriptions sont closes -->

        <div v-else
          class="d-flex align-center justify-center ga-1 bg-dark-red text-white rounded py-2 px-1 font-weight-600 cursor-disabled">
          <v-icon icon="mdi-pencil-off-outline"></v-icon>
          {{ get_inscription_closed_text() }}
        </div>


      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
import CourseProperties from "@/components/Home/Courses/Course_Properties.vue";
import TarifsCourse from "@/components/Home/Courses/Tarifs_Course.vue";
import CourseInformationsTruncated from "@/components/Home/Courses/CourseInformationsTruncated.vue";
export default {
  props: ["course"],
  components: { CourseProperties, TarifsCourse, CourseInformationsTruncated },
  computed: {
    ...mapStores(useMainStore),
    show_inscription_button() {
      const course_selectionable = this.course.is_selectionnable(
        this.mainStore.module.status,
        this.mainStore.view_as_admin,
        this.mainStore.inscription_as_admin,
        this.mainStore.inscription_vip,
        this.mainStore.module.courses,
        this.mainStore.module.is_complet,
        this.mainStore.bookingSystem?.groupe
      );

      return course_selectionable;
    },
    has_preinscriptions() {
      return this.course.has_preinscriptions();
    },
    display_depart() {
      return this.course.display_depart_on_home();
    },
    date_depart() {
      return this.course.get_readable_date_depart();
    },
    heure_depart() {
      return this.course.get_readable_heure_depart();
    },

    all_courses() {
      return this.mainStore.module.courses;
    },
  },
  methods: {
    get_background(course) {
      if (course.metadatas.couleur_fond) {
        return course.metadatas.couleur_fond + " !important";
      } else {
        return "";
      }
    },
    /* Si clic sur button _s'inscrire_ on ajoute en mémoire la préselection pour l'ajouter à la sélection de parcours du premier coureur en page suivante */
    async addToPreselection(course) {
      this.mainStore.bookingSystem.preselection = { type: "course", value: course.id, course: course };

      this.$router.push({ name: "Inscriptions" });
    },
    get_inscription_closed_text() {
      if (this.mainStore.module.status == 'avant_ouverture') {
        return 'A venir';
      }
      else if (this.mainStore.module.status == 'apres_fermeture') {
        return 'Fermé';
      }
      else if (this.course.is_complet(this.all_courses)) {
        return 'Complet';
      }
      else if (this.mainStore.module.is_complet) {
        return 'Complet';
      }
      else {
        return 'Inscriptions closes';
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>